const ACTIVE = 1;
const PASSIVE = 2;
const BLOCKED = 3;
export default {
    ACTIVE: ACTIVE,
    PASSIVE: PASSIVE,
    BLOCKED: BLOCKED,
};